<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  gridClassName="user-output-logs-grid"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
></app-data-grid>
